import PageLayout from './ContentPageLayout'

export default PageLayout
